
<div *ngIf="popup_type == 'validateBlacklistPopup'">
    <div class="std-ta-center">
        <h3 nxHeadline="subsection-large" class="nx-margin-bottom-m">WARNING</h3>
        <p nxCopytext="normal" class="nx-font-weight-light nx-margin-bottom-m">
            {{popup_error}}
        </p>
        <button nxModalClose class="nx-margin-bottom-m" nxButton="primary" type="button">
            OK
        </button>
    </div>
</div>

<div *ngIf="popup_type == 'warningPopup'">
    <div class="std-ta-center">
        <h3 nxHeadline="subsection-large" class="nx-margin-bottom-m">WARNING</h3>
        <p nxCopytext="normal" class="nx-font-weight-light nx-margin-bottom-m">
            {{popup_error}}
        </p>
        <button nxModalClose class="nx-margin-bottom-m" nxButton="primary" type="button">
            OK
        </button>
    </div>
</div>

<div *ngIf="popup_type == 'populateActiveQuotationDetails'">
    <div nxModalContent>
        <h3 nxHeadline="subsection-large" class="nx-margin-bottom-m">
            Warning
        </h3>
        <p nxCopytext="normal" class="nx-margin-bottom-m nx-font-weight-light">
            There is an existing quotation {{activeQuotationDetails?.cngeNote?.proposalNo}} for this vehicle, last
            updated
            on {{activeQuotationDetails?.cngeNote?.updateDate | date:'dd/MM/yyyy'}}. Would you like to retrieve this
            quotation instead of creating a
            new one?
        </p>
    </div>

    <button nxModalClose class="button_popup_2btn" nxButton="primary" type="button" (click)="onClickYes()">
        YES
    </button>
    <button nxModalClose nxButton="primary" type="button">
        NO
    </button>
</div>